import React from 'react';

const Project = ({url, logo, title, desc}) => {
  return (
    <>
        <div className="projectBody">
            <div className='projectHex'>
                <div className='projectHexBackground'>
                    <img src={logo} alt="the-logo"></img>
                </div>
            </div>
            <div className='projectInfo'>
                <h3 className='projectTitle'><a href={url} rel="noreferrer" target="_blank">{title}</a></h3>
                <p>{desc}</p>
            </div>
        </div>

    </>
  );
};

export default Project;
